import {postAction} from "@/eiuov-utils/axios/api";

const queryPersonAction = (params) => postAction("/reception/person/queryPerson", params)
const queryPersonByCoverArea = (params) => postAction("/reception/person/queryPersonByCoverArea", params)

const queryPerson = (params) => postAction("/person/queryPerson", params)
const queryPersonByWorksGuid = (params) => postAction("/person/queryPersonByWorksGuid", params)

const queryWorkAction = (params) => postAction("/works/queryWorks", params)
const queryOneMusic = (params) => postAction("/reception/works/queryOneMusic", params)
const queryWorksListAction = (params) => postAction("/reception/works/queryWorksList", params)
const queryWorksPageAction = (params) => postAction("/reception/works/queryWorksPage", params)
const queryWorksDetailAction = (params) => postAction("/reception/works/queryWorksDetail", params)
const queryPersonAndWorksDescription = (params) => postAction("/reception/works/queryPersonAndWorksDescription", params)
const queryStarLightList = (params) => postAction("/reception/works/queryStarLightList", params)
const queryWorksStarLightByisUsed = (params) => postAction("/reception/works/queryWorksStarLightByisUsed", params)
const calculatedWidthByWork = (params) => postAction("/reception/works/calculatedWidthByWork", params)
const queryWorksByPersonName = (params) => postAction("/reception/works/queryWorksByPersonName", params)
const queryAllAuthorsAndAuthorWorks = (params) => postAction("/reception/works/queryAllAuthorsAndAuthorWorks", params)


const queryWorksAttachByTargetInfo = (params) => postAction("/reception/works/queryWorksAttachByTargetInfo", params)
const queryVideoFrequencyByWorkId = (params) => postAction("/reception/works/queryVideoFrequencyByWorkId", params)





export {
  queryPersonAction,
  queryWorksPageAction,
  queryWorksListAction,
  queryWorksDetailAction,
  queryPersonByWorksGuid,
  queryWorkAction,
  queryPerson,
  queryPersonAndWorksDescription,
  queryStarLightList,
  queryPersonByCoverArea,
  queryOneMusic,
  queryWorksStarLightByisUsed,
  calculatedWidthByWork,
  queryWorksByPersonName,
  queryWorksAttachByTargetInfo,
  queryAllAuthorsAndAuthorWorks,
  queryVideoFrequencyByWorkId,
}
